import React from 'react';
import moment from 'moment';
import LocationMap from './location_map';
import 'leaflet/dist/leaflet.css';
import MapPinIcon from '@heroicons/react/24/solid/esm/MapPinIcon';
import { BriefcaseIcon, FingerPrintIcon, DocumentTextIcon } from '@heroicons/react/20/solid';

const InOutsModal = ({ isOpen, onClose, locations, checkPermissionTimbratura, isEmployee, employeeDetails  }) => {
  const [showMap, setShowMap] = React.useState(null);  
  if (!isOpen) return null;
  
  const inouts = locations?.inouts || [];
  const justificationRequests = locations?.justification_requests || [];
  const shifts = locations?.shifts || [];

  const showContent = !isEmployee || checkPermissionTimbratura;
  
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      style={{ zIndex: '999' }}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 pt-2 w-3/4 max-w-lg relative"
        style={{ maxHeight: '90vh', overflowY: 'auto', padding: '1.5rem 1.5rem 1rem' }}
      >
        <button
          className="absolute top-2 right-4 text-gray-400 hover:text-gray-600"
          onClick={onClose}
        >
          &#x2715;
        </button>
        {employeeDetails?.cf && (
          <h2 className='text-left text-sm text-gray-800 pb-6'>Dipendente: <span className='font-semibold uppercase'> 
          {employeeDetails.last_name && employeeDetails.first_name
            ? `${employeeDetails.last_name} ${employeeDetails.first_name}`
            : employeeDetails.cf}</span></h2>
        )}

        <h2 className="text-lg font-bold text-center text-indigo-500"><BriefcaseIcon className="h-6 w-6 text-indigo-500 mr-1 inline-block" /> Dettagli Turno</h2>
        <div>
          {shifts?.length > 0 ? (
            <table className="min-w-full table-auto mb-3">
              <thead>
                <tr className='border-b'>
                  <th className="px-4 py-2 text-left text-sm font-semibold text-gray-800">Fasce Orarie Lavoro</th>
                  <th className="px-4 py-2 text-left text-sm font-semibold text-gray-800">Pause</th>
                </tr>
              </thead>
              <tbody>
                {shifts.map((shift, index) => (
                  <React.Fragment key={index}>
                    {shift.status === false && (
                      <tr>
                        <td colSpan={2} className="px-4 pt-1 text-sm font-semibold text-gray-800">
                          <div className="flex items-center">
                            <div className="w-3 h-3 bg-sky-200 rounded-full mr-2"></div>
                            Turno da confermare
                          </div>
                        </td>
                      </tr>
                    )}

                    {shift.time_slots.map((timeSlot, idx) => (
                      <tr key={`${index}-${idx}`} className='border-b'>
                        <td className="px-4 py-2 text-sm text-gray-800">
                          {timeSlot.start_at} - {timeSlot.end_at}
                        </td>
                        <td className="px-4 py-2 text-sm text-gray-600">
                          {timeSlot.breaks?.length > 0 ? (
                            <ul>
                              {timeSlot.breaks.map((breakSlot, bIdx) => (
                                <li key={bIdx}>
                                  {breakSlot.start_at} - {breakSlot.end_at}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <div className="text-left text-sm text-gray-600">Nessuna pausa</div>
                          )}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>

            </table>
          ) : (
            <div className="px-4 py-2 text-left text-sm text-gray-800">Nessun orario lavorativo</div>
          )}
        </div>

        {justificationRequests?.length > 0 && (
          <div className='mb-3'>
            <h2 className="text-lg font-bold text-center text-orange-500 pb-2 pt-4"><DocumentTextIcon className="h-6 w-6 text-orange-500 mr-1 inline-block" /> Giustificativi</h2>
            {/* <h3 className="text-md font-semibold mt-4 text-orange-500">Giustificativi</h3> */}
            <ul>
            {justificationRequests.map((justification, idx) => {
              const justificationFrom = moment(justification.datetime_from);
              const justificationTo = moment(justification.datetime_to);

              const justificationFromFormatted = justificationFrom.format('HH:mm');
              const justificationToFormatted = justificationTo.format('HH:mm') === '00:00' ? '24:00' : justificationTo.format('HH:mm');
              const descriptionJustification = justification.justification.justification.description;

              return (
                <li key={idx}>
                  <span className='pl-4 py-2 text-left text-sm font-semibold text-gray-800'>{descriptionJustification}:</span> 
                  <span className='pl-1 py-2 text-sm text-gray-800'>dalle ore{' '}
                  {justificationFromFormatted} alle ore {justificationToFormatted}</span>
                </li>
              );
            })}

            </ul>
          </div>
        )}

        {showContent && (
          <>
            <h2 className="text-lg font-bold text-center text-indigo-500 pt-4 pb-1"><FingerPrintIcon className="h-6 w-6 text-indigo-500 mr-1 inline-block" /> Timbrature</h2>
            {inouts?.length > 0 ? (
              <div>
                <ul>
                  {inouts
                  .sort((a, b) => moment(a.checkin).valueOf() - moment(b.checkin).valueOf())
                  .map((inout) => {
                    const checkinFormattedHour = moment(inout.checkin).format('DD/MM/YYYY') + ',';
                    const checkinFormattedMinute = moment(inout.checkin).format('HH:mm');
                    const checkoutFormattedHour = inout.checkout
                      ? moment(inout.checkout).format('DD/MM/YYYY') + ','
                      : 'In corso';
                    const checkoutFormattedMinute = inout.checkout
                      ? moment(inout.checkout).format('HH:mm')
                      : '';

                    const checkinCoordinatesAvailable = inout.checkin_lat && inout.checkin_lng;
                    const checkoutCoordinatesAvailable = inout.checkout_lat && inout.checkout_lng;

                    const haveToShowMap = showMap === inout.id;
                    const convertedLocations = [];

                    if (checkinCoordinatesAvailable) {
                      convertedLocations.push({
                        latitude: inout.checkin_lat,
                        longitude: inout.checkin_lng,
                        accuracy: inout.checkin_accuracy || 50,
                        checkin: inout.checkin,
                        type: 'checkin',
                      });
                    }

                    if (checkoutCoordinatesAvailable) {
                      convertedLocations.push({
                        latitude: inout.checkout_lat,
                        longitude: inout.checkout_lng,
                        accuracy: inout.checkout_accuracy || 50,
                        checkout: inout.checkout,
                        type: 'checkout',
                      });
                    }

                    return (
                      <li className="mb-2" key={inout.id}>
                        <span className='pl-4 py-2 text-left text-sm font-semibold text-gray-800'>Entrata: </span> 
                        <span className='py-2 text-sm text-gray-800'>{checkinFormattedHour} {checkinFormattedMinute}</span> <br />
                        <span className='pl-4 py-2 text-left text-sm font-semibold text-gray-800'>Uscita: </span> 
                        <span className='py-2 text-sm text-gray-800'>{checkoutFormattedHour} {checkoutFormattedMinute}</span> <br />

                        {checkinCoordinatesAvailable || checkoutCoordinatesAvailable ? (
                          <div>
                            {haveToShowMap && (
                              <div
                                style={{ height: '60vh', width: '100%', marginTop: '5px', marginBottom: '5px' }}
                              >
                                <LocationMap locations={convertedLocations} />
                              </div>
                            )}
                            {haveToShowMap ? (
                              <button
                                className="text-indigo-700 text-sm font-semibold"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setShowMap(null)}
                              >
                                <MapPinIcon className="inline-block h-5 w-5 me-1 mb-1" /> Nascondi posizione
                              </button>
                            ) : (
                              <button
                                className="text-indigo-700 text-sm font-semibold"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setShowMap(inout.id)}
                              >
                                <MapPinIcon className="inline-block h-5 w-5 me-1 my-2" /> Visualizza posizione
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className='px-4 py-2 text-left text-sm text-gray-800'>
                            Posizione non registrata
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              <div className='px-4 py-2 text-left text-sm text-gray-800'>
                Timbratura non registrata
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InOutsModal;
